<template>
  <div class="home">
    <RoleList  @clicked="onClickChild" @newRole="onClickChildNew" @editRole="onClickChild" v-show="listView" :scroll="corY" ref="refreshList" />
    <RoleForm :role="role" v-show="formView" @backClicked="onBackChild" />
  </div>
</template>

<script>
// @ is an alias to /src
import RoleList from '@/components/role/RoleList.vue'
import RoleForm from '@/components/role/RoleForm.vue'

export default {
  name: 'Role',
  data () {
    return {
      role: {
        id: null,
        name: null,
        permissions: {
          master: false,
          product: false,
          purchasing: false,
          price: false,
          user: false,
          promo: false,
          sales: false,
          customer: false,
          project: false,
          workshop: false,
          manufacture: false,
          payment: false,
          finance: false,
          finance_report: false,
          message: false,
          margin_on_sales: false
        }
      },
      corX: 0,
      corY: 0,
      listView: true,
      formView: false
    }
  },
  components: {
    RoleList,
    RoleForm
  },
  methods: {
    onClickChild: function (value) {
      this.role = value
      this.listView = false
      this.formView = true
    },
    onClickChildNew: function () {
      this.role = {
        id: null,
        name: null,
        permissions: {
          master: false,
          product: false,
          purchasing: false,
          price: false,
          user: false,
          promo: false,
          sales: false,
          customer: false,
          project: false,
          workshop: false,
          manufacture: false,
          payment: false,
          finance: false,
          finance_report: false,
          message: false,
          margin_on_sales: false
        }
      }
      this.listView = false
      this.formView = true
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.role = {
        id: null,
        name: null,
        permissions: {
          master: false,
          product: false,
          purchasing: false,
          price: false,
          user: false,
          promo: false,
          sales: false,
          customer: false,
          project: false,
          workshop: false,
          manufacture: false,
          payment: false,
          finance: false,
          finance_report: false,
          message: false,
          margin_on_sales: false
        }
      }
      this.$refs.refreshList.refreshRole()
    }
  },
  mounted () {
    this.$store.dispatch('getRowTable')
  }
}
</script>
